<mat-tree #tree [dataSource]=dataSource [childrenAccessor]="childrenAccessor" class="component-tree">
  <!-- This is the tree node template for leaf nodes -->

  <mat-nested-tree-node *matTreeNodeDef="let node">
    {{ node.element.name?.[0] }}
  </mat-nested-tree-node>


  <!-- This is the tree node template for expandable nodes -->
  <!--#treeNodeRef="matNestedTreeNode" the instance of the directive or component that is exported under the name matNestedTreeNode-->
  <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild"
                        [cdkTreeNodeTypeaheadLabel]="node.name"
                        (click)="loadChildren(node)"
                        matTreeNodeToggle
                        #treeNodeRef='matNestedTreeNode'>
    @let element = node.element;
    <div class="connector-container" [style.--level]="getConnectorLevel(treeNodeRef.level, false)">
      <!--To create an array of a specific length-->
      @for (index of getArray(treeNodeRef.level, false); track index) {
        <!-- TODO : avoid calling n time the getAllConnectors (removing this function from the for loop and removing the index from the function) -->
        @let connector = getAllConnectors(treeNodeRef._getSetSize(), node, index, treeNodeRef.level)[index];
        <div class="connector" [ngClass]="connector?.type" [attr.data-shape]="connector?.shape"
             [matTooltip]="connector?.type">
        </div>
      }
    </div>

    <div class="mat-tree-node" [style.--level]="getConnectorLevel(treeNodeRef.level, false)">
      <div class="left">
        <mat-icon class="symbol-icon"
                  [matTooltip]="getSymbol(element).tooltip"
                  [svgIcon]="moleculeView()? getSymbol(element.icon).name: getSymbol(element).name">
        </mat-icon>

        <div class="toggle-icon-container" [attr.aria-label]="'Toggle ' + element.name">
          <mat-icon class="mat-icon-rtl-mirror"
                    [svgIcon]="tree.isExpanded(node) ? 'collapse' : 'expand'">
          </mat-icon>
        </div>
        <span class="name" #name
              [matTooltip]="element.name?.[0]"
              [matTooltipDisabled]="!isEllipsisActive(name)">

             @if (node.stoichiometry > 1) {
               <b>{{ node.stoichiometry }} ×</b>
             }
          {{ getDisplayName(node, element) }}
        </span>
      </div>


      <div class="right">

        @if(moleculeView() && node.highlight){
          <span class="highlight-tag">📌</span>
        }

        @if(moleculeView()) {
          <span class="molecule name">
            {{getMoleculeIdentifier(node, element)}}
          </span>
        }

        <!--Compartment-->
        @for (comp of getCompartments(element); track comp) {
          <span class="compartment name"
                #compartment
                [matTooltip]="comp"
                [matTooltipDisabled]="!isEllipsisActive(compartment)">
            {{ comp }}
          </span>
        }

        <!--Species-->
        @let finalSpeciesName = getSpeciesName(element);
        @if (finalSpeciesName) {
          <span class="species name" #speciesName
                [matTooltip]="element.speciesName"
                [matTooltipDisabled]="!isEllipsisActive(speciesName)">
            {{ finalSpeciesName }}
          </span>
        }

        @if(!moleculeView()){
          <div class="select-container">
            <!-- stopPropagation() prevent the matTreeNodeToggle event from triggering when clicking-->
            <button mat-icon-button class="button" (click)="onSelectClick($event, element)">
              <mat-icon class="custom-icon" [svgIcon]="'select'"></mat-icon>
            </button>
          </div>
        }

        <div class="goTo-container">
          <a [href]="getUrl(element)" target="_blank" (click)="$event.stopPropagation()">
            <mat-icon class='custom-icon' [svgIcon]="'double-arrow-right'"></mat-icon>
          </a>
        </div>
      </div>
    </div>


    <!-- Add this details-group and details-tree is for making the connector works in Firefox, to make the mat-nested-tree to take the full height of the parent -->
    <div [class.component-tree-invisible]="!tree.isExpanded(node)" role="group" class="group"
         [class.details-group]="!isNestedView(node.element) && tree.isExpanded(node) ? 'details-group' : ''">
      <!--make sure getting full object content to render with _selectedTreeNodeData.hasValue()-->
      <ng-container
        *ngIf="!isNestedView(node.element) && _selectedTreeNodeData.hasValue(); then details; else entity">
      </ng-container>
    </div>

    <!-- Template for child nodes when parent is EWAS (protein) or Event -->
    <ng-template #details>
      <!-- stopPropagation() prevent the matTreeNodeToggle event from triggering when clicking-->
      <mat-nested-tree-node class='details-tree' (click)="$event.stopPropagation()">
        <div class="details-connector-container"
             [style.--level]="getConnectorLevel(treeNodeRef.level, true)">
          <!--To create an array of a specific length-->
          @for (index of getArray(treeNodeRef.level, true); track index) {
            @let connector = index != getArray(treeNodeRef.level, true).length - 1 ?
              getParentsConnector(node, true)[index] : {type: 'is', shape: 'L'};
            <div class="connector" [ngClass]="connector?.type" [attr.data-shape]="connector?.shape"
                 [matTooltip]="connector?.type">
            </div>
          }
        </div>

        @if (!moleculeView()) {
         <!--Point to entity details which contains more data and provide protein structure only-->
          <cr-object-tree-details [obj]="element"
                             [className]="element.className"
                             [refEntity]="element.referenceEntity"
                             [xRefs]="element.referenceEntity.crossReference">
          </cr-object-tree-details>

        } @else {
          <!--Point to molecule details which provide structure and xRefs-->
          @if (_selectedTreeNodeData.hasValue()) {
            <cr-molecule-details [obj]="element" [xRefs]="element.crossReference"></cr-molecule-details>
          }
        }

      </mat-nested-tree-node>
    </ng-template>

    <!-- Default child template for nested entities-->
    <ng-template #entity>
      <ng-container matTreeNodeOutlet></ng-container>
    </ng-template>

  </mat-nested-tree-node>
</mat-tree>


